<template>
  <v-app>
    <router-view />
    <Snackbar></Snackbar>
    <SignInDialog></SignInDialog>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-app>
</template>

<script>
import Snackbar from "@/components/_partial/Snackbar";
import SignInDialog from "@/components/SignInDialog";
import ConfirmDialog from "@/components/ConfirmDialog";
import { createSocket } from "@/plugins/websocket";
import { mapMutations, mapState } from "vuex";
export default {
  components: { Snackbar, SignInDialog, ConfirmDialog },
  computed: {
    ...mapState("user", ["isLogin"])
  },
  methods: {
    ...mapMutations("user", ["checkCookie"])
  },
  created() {
    this.checkCookie();
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    if (this.isLogin && window.WebSocket) {
      createSocket(this.getWSURL());
    }
  }
};
</script>

<style lang="scss" scoped>
.v-application {
  line-height: normal;
  &.theme--dark {
    background: #171c25 !important;
  }
  &.theme--light {
    background: #f2f6ff !important;
  }
}
</style>
